import * as types from "../../actions/tags/types";

const initialState = {
  isInitialLoaded: false,
  isInitialFetching: false,
  hasFetchError: false,
  initialList: [],
  autocomplete: {},
};

export default function tags(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_INITIAL_TAGS_REQUEST: {
      return Object.assign({}, state, {
        isInitialFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_INITIAL_TAGS_SUCCESS: {
      return Object.assign({}, state, {
        isInitialFetching: false,
        isInitialLoaded: true,
        initialList: action.tags.map(tag => tag.name),
      });
    }
    case types.FETCH_INITIAL_TAGS_FAILURE: {
      return Object.assign({}, state, {
        isInitialFetching: false,
        isInitialLoaded: false,
        hasFetchError: true,
      });
    }

    case types.FETCH_AUTOCOMPLETE_TAGS_REQUEST: {
      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: {
          isFetching: true,
          isLoaded: false,
          list: [],
        },
      });

      return Object.assign({}, state, { autocomplete });
    }

    case types.FETCH_AUTOCOMPLETE_TAGS_SUCCESS: {
      const queryState = Object.assign({}, state.autocomplete[action.query], {
        isFetching: false,
        isLoaded: true,
        list: action.tags, // No need to extract name, representation in the response differs
      });

      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: queryState,
      });

      return Object.assign({}, state, { autocomplete });
    }

    case types.FETCH_AUTOCOMPLETE_TAGS_FAILURE: {
      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: {
          isFetching: false,
          isLoaded: false,
          list: [],
        },
      });

      return Object.assign({}, state, { autocomplete });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tags/index.js